import { PaginationQueryObject, QueryConfig } from "./Queries";
import { CustomerRequest } from "../../routeComponents/Customer/Customer";

export const customersListQuery = (
  filter: any,
  pagination: PaginationQueryObject
): QueryConfig => {
  const query = `query getCustomersList($filter: CustomerFilter, $pagination: PaginationInput) {
            customers(filter: $filter, paginationInput: $pagination) {
                items { id, name, velocityEhsCustomerNumber, fullyIntegrated, customerDomainName, active,  },
                pageInfo { pageSize, pageNumber, totalElements, totalPages, hasNext, hasPrevious }
            }
        }`;
  return {
    query: query,
    variables: {
      filter: filter,
      pagination: pagination,
    },
  };
};

export const getCustomerQuery = (customerId: string) => {
  const query = `query getCustomer($customerId: ID) {
            customer(id: $customerId) {
                id, customerDomainName, name, velocityEhsCustomerNumber, customerOu, numberOfUsers,
                active, locationManagementEnabled, orgHierarchyManagementEnabled, fullyIntegrated
            }
        }`;
  return {
    query,
    variables: {
      customerId: customerId,
    },
  };
};

export const createCustomerMutation = (input: CustomerRequest): QueryConfig => {
  const query = `mutation handleCreateCustomer($input: CustomerCreateInput!) { 
            createCustomer(input: $input) { id }
        }`;
  return {
    query: query,
    variables: {
      input: {
        name: input.name,
        customerDomainName: input.customerDomainName,
        velocityEhsCustomerNumber: input.velocityEhsCustomerNumber,
        locationManagementEnabled: input.locationManagementEnabled,
        orgHierarchyManagementEnabled: input.orgHierarchyManagementEnabled,
        fullyIntegrated: input.fullyIntegrated,
        admin: input.admin,
      },
    },
  };
};

interface EditCustomerInput {
  id: string;
  name: string;
  velocityEhsCustomerNumber: string;
  fullyIntegrated: boolean;
}

export const updateCustomerMutation = (
  input: EditCustomerInput
): QueryConfig => {
  const query = `mutation handleUpdateCustomer($input: EditCustomerInput!) { 
            updateCustomer(input: $input) { id }
        }`;
  return {
    query,
    variables: { input },
  };
};

export const updateCustomerStatusMutation = (
  customerId: string,
  status: boolean
): QueryConfig => {
  const query = `mutation handleUpdateCustomer($customerID: ID!, $active: Boolean) { 
            updateCustomer(input: {
                id: $customerID,
                active: $active,
            }) { id }
        }`;
  return {
    query,
    variables: {
      customerID: customerId,
      active: status,
    },
  };
};

export const customerApplicationsQuery = (
  customerId: string,
  filter?: any,
  pagination?: PaginationQueryObject
): QueryConfig => {
  const query = `query getCustomerApplications($customerId: ID, $filter: ApplicationFilter, $pagination: PaginationInput) {
            customer(id: $customerId) {
                applications(filter: $filter, paginationInput: $pagination) {
                    items { id, name, isAssigned, productLine{name} },
                    pageInfo { pageSize, pageNumber, totalElements, totalPages, hasNext, hasPrevious }
                }
            }
        }`;
  return {
    query: query,
    variables: {
      customerId: customerId,
      filter: filter,
      pagination: pagination,
    },
  };
};

export const getCustomerApplicationsQuery = (
  customerId: string,
  filter?: any,
  pagination?: PaginationQueryObject
): QueryConfig => {
  const query = `query getCustomerApplications($customerId: ID, $filter: ApplicationFilter, $pagination: PaginationInput) {
            customer(id: $customerId) {
                applications(filter: $filter, paginationInput: $pagination) {
                    items { id, name, isAssigned, productLine { name }, applicationUrl },
                    pageInfo { pageSize, pageNumber, totalElements, totalPages, hasNext, hasPrevious }
                }
            }
        }`;
  return {
    query: query,
    variables: {
      customerId: customerId,
      filter: filter,
      pagination: pagination,
    },
  };
};

interface SetCustomerLocationManagementInput {
  id: string;
  locationManagementEnabled: boolean;
  orgHierarchyManagementEnabled: boolean;
}

export const setCustomerLocationManagement = (
  input: SetCustomerLocationManagementInput
): QueryConfig => {
  const query = `mutation ($input: SetCustomerLocationManagementInput) { 
    setCustomerLocationManagement(input: $input) { id }
  }`;
  return {
    query: query,
    variables: {
      input,
    },
  };
};
